// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box-shadow[data-v-854c1c86]{z-index:5;box-shadow:0 2px 4px rgba(94,94,94,.29412);background:linear-gradient(60deg,#543ab7,#00acc1);color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
